import React, { FormEvent, useEffect, useState, FC } from 'react';
import TextField from '@material-ui/core/TextField';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Page } from '../../Page';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import Button from '@material-ui/core/Button';
import { Creature } from '../../../../entities/Entities';
import { FormLabel } from '@material-ui/core';
import { RouteComponentProps, Link, useHistory } from 'react-router-dom';
import {
  creatureAddEndpoint,
} from '../../../../api/Endpoints';
import {
  adminCreatureEdit,
  adminCreatureView,
  adminCreatureTable,
} from '../../../../api/PageLinks';
import { AdminTopSideBar } from '../../../../components/AdminTopSideBar';
import Cookies from 'js-cookie';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiTextField-root': {
        margin: theme.spacing(1),
        width: '25ch',
      },
    },
    name_input: {
      width: '300px',
    },
  }),
);

export const CreatureAddPage = () => {
  const classes = useStyles();

  const [submited, setSubmitted] = useState<boolean>(false);
  const [name, setName] = useState<string>('');
  const [description, setDescription] = useState<string>('');

  const history = useHistory();
  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (submited === false) {
      setSubmitted(true);
      fetch(creatureAddEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + Cookies.get('token')
        },
        // We convert the React state to JSON and send it as the POST body
        body: JSON.stringify({ name: name, description: description }),
      }).then((res) => res.json())
      .then((jsonData) => {
        let creature: Creature = jsonData;
        //Fill in form with creature data
        history.push(adminCreatureView + creature.id.toString());
      })
      .catch((err) => {
        console.error(err);
        history.push(adminCreatureTable);
      });
    }
  };

  return (
    <div>
      <AdminTopSideBar />
      <Page title="Creature add">
        <form
          className={classes.root}
          autoComplete="off"
          onSubmit={handleSubmit}
          css={css`
            list-style: none;
            margin: 10px 0 0 0;
            padding: 20px 20px;
            background-color: #fff;
            border-radius: 8px 8px;
            box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.16);
          `}
        >
          <FormLabel>New creature</FormLabel>
          <div>
            <TextField
              required
              id="creature-name-field"
              label="Name"
              defaultValue={name}
              style={{ width: '400px', maxWidth: '100%' }}
              type="text"
              onChange={(evt) => setName(evt.target.value)}
            />
          </div>
          <br />
          <div>
            <TextField
              id="creature-description-field"
              label="Description"
              defaultValue={description}
              variant="outlined"
              multiline={true}
              rows={5}
              style={{ width: '100%' }}
              onChange={(evt) => setDescription(evt.target.value)}
            />
          </div>
          <br />
          <Button variant="contained" type="submit">
            Save
          </Button>
        </form>
      </Page>
    </div>
  );
};
